module.exports = __webpack_public_path__ + "static/media/cobru_pro_plantilla.4ce26e25.xlsx";